import { render, staticRenderFns } from "./PrintStones.vue?vue&type=template&id=b86b807a&scoped=true&"
import script from "./PrintStones.vue?vue&type=script&lang=js&"
export * from "./PrintStones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86b807a",
  null
  
)

export default component.exports